var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4944 8.6832C11.3872 8.5512 11.2072 8.5024 11.0488 8.5592C10.6048 8.7184 10.1232 8.8 9.61602 8.8C7.18962 8.8 5.21602 6.8256 5.21602 4.4C5.21602 2.94 5.93682 1.5808 7.14402 0.7632C7.28082 0.6704 7.34642 0.5032 7.30962 0.3424C7.27282 0.1816 7.14082 0.06 6.97682 0.036C6.78962 0.0088 6.60322 0 6.41602 0C3.10722 0 0.416016 2.6912 0.416016 6C0.416016 9.3088 3.10722 12 6.41602 12C8.51602 12 10.4264 10.9328 11.5248 9.1456C11.6136 9.0008 11.6008 8.816 11.4944 8.6832Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightIcon);
export default __webpack_public_path__ + "static/media/night_icon.cc2d37f1d040e3b3b6c75bd69824a609.svg";
export { ForwardRef as ReactComponent };